const initialState = {
  items: []
};

function customReducer(state = initialState, action) {
  switch (action.type) {
    case "ADD_ITEM":
      return {
        ...state,
        items: [
          ...state.items,
          action.id
        ]
      };
    case "REMOVE_ITEM":
      return {
        ...state,
        items: state.items.filter(item => item !== action.id)
      };
    default:
      return state;
  }
}

export default customReducer;



// WEBPACK FOOTER //
// ./src/customReducer.js